<template>
    <BreadCrumb PageTitle="Liste des avis" />
    <ListeAvis/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeAvis from "../../components/Avis/ListeAvis.vue";

    export default defineComponent({
      name: "ListeAvisPage",
      components: {
        BreadCrumb,
        ListeAvis,
      },
    });
  </script>